import { render, staticRenderFns } from "./RegionTeam.vue?vue&type=template&id=7f3789f2&scoped=true&"
import script from "./RegionTeam.vue?vue&type=script&lang=js&"
export * from "./RegionTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3789f2",
  null
  
)

export default component.exports